import { __assign } from "tslib";
import { normalizeBoolean } from "./utils/normalizeBoolean";
import { normalizeEndpoint } from "./utils/normalizeEndpoint";
export var resolveCustomEndpointsConfig = function (input) {
    var _a;
    return (__assign(__assign({}, input), { tls: (_a = input.tls) !== null && _a !== void 0 ? _a : true, endpoint: normalizeEndpoint(input), isCustomEndpoint: true, useDualstackEndpoint: normalizeBoolean(input.useDualstackEndpoint) }));
};
